import { faEye, faRectangleXmark } from "@fortawesome/free-regular-svg-icons";
import {
  faCheck,
  faPenToSquare,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import BackButton from "../common/backButton";
import consts from "../consts";

function UpdateEmpresa({ auth }) {
  const { cnpj } = useParams();
  const [empresa, setEmpresa] = useState([]);
  const empresaInfo = empresa[0];
  const [updateEmpresa, setUpdateEmpresa] = useState(false);
  const [values, setValues] = useState([]);

  const searchEmpresa = async () => {
    try {
      const resp = await axios.get(`${consts.API_URL}/bancariosCnpj`, {
        params: { cnpj },
      });
      setEmpresa(resp.data);
    } catch (error) {
      console.log("Erro ao buscar empresa:", error);
    }
  };

  useEffect(() => {
    searchEmpresa();
  }, [cnpj]);

  useEffect(() => {
    if (empresa.length > 0) {
      const valoresIniciais = empresa.map((conta) => ({
        id: conta.id,
        cnpj: conta.cnpj,
        razaosocial: conta.razaosocial,
        banco: conta.banco,
        fid: conta.fid,
        agencia: conta.agencia,
        conta: conta.conta,
        codcontabil: conta.codcontabil,
        user: auth.user.name,
      }));
      setValues(valoresIniciais);
    }
  }, [auth.user.name, empresa]);

  const changeValues = (e, index) => {
    const { name, value } = e.target;
    setValues((prev) => {
      //Se o campo editado for cnpj ou razaosocial
      if (name === "cnpj" || name === "razaosocial") {
        return prev.map((item) => ({
          ...item,
          [name]: value,
        }));
      } else {
        const newValues = [...prev];
        newValues[index] = { ...newValues[index], [name]: value };
        return newValues;
      }
    });
  };

  const handleUpdateEmpresa = (data) => {
    axios
      .put(`${consts.API_URL}/bancarios/${data.id}`, data)
      .then(() => {
        toast.success("Dados atualizados com sucesso!");
        setUpdateEmpresa(false);
        searchEmpresa();
      })
      .catch((error) => {
        console.log(`Erro ao atualizar empresa: ${error}`);
        toast.error("Não foi possível atualizar estes dados.");
      });
  };

  return (
    <div className="min-h-screen dark:bg-[#121212] dark:text-white">
      <div className="container h-full mx-auto">
        {updateEmpresa ? (
          <>
            <div className="flex">
              <BackButton path="bancarios" text="Voltar" />
            </div>
            <div className="flex">
              <span className="text-4xl font-bold mt-3">
                Editar Dados da Empresa
              </span>
            </div>

            <div
              div
              className="grid justify-between grid-cols-[1fr_3fr_0.9fr] p-2 mt-5 text-center font-bold  dark:bg-slate-700"
            >
              <span>CNPJ</span>
              <span>Empresa</span>
              <div className="flex flex-row justify-evenly">
                <span>Ações</span>
              </div>
            </div>

            <div className="grid w-full grid-cols-[1fr_3fr_0.9fr] p-2 dark:bg-slate-800 gap-2 place-items-center font-medium bg-blue-50 mb-3 rounded-xl">
              <input
                className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center "
                onChange={(e, index) => changeValues(e, index)}
                name="cnpj"
                value={values[0]?.cnpj || ""}
              />
              <input
                className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center w-[280px]"
                onChange={(e, index) => changeValues(e, index)}
                name="razaosocial"
                value={values[0]?.razaosocial || ""}
              />
              <div className=" grid grid-cols-2 items-center gap-3 text-center rounded-md dark:bg-yellow-700 dark:text-white p-2">
                <Tooltip title="Confirmar">
                  <button
                    onClick={() => {
                      handleUpdateEmpresa(values[0]);
                    }}
                    className="px-4 py-2 bg-[#41A700] rounded-md hover:bg-[#308941]"
                  >
                    <FontAwesomeIcon icon={faCheck} size="lg" />
                  </button>
                </Tooltip>
                <Tooltip title="Cancelar">
                  <button
                    className="px-4 py-2 bg-[#999999] rounded-md hover:bg-[#999999] text-white"
                    onClick={() => setUpdateEmpresa(false)}
                  >
                    <FontAwesomeIcon icon={faRectangleXmark} size="lg" />
                  </button>
                </Tooltip>
              </div>
            </div>

            <div
              div
              className="grid justify-between grid-cols-[1fr_1fr_1fr_1fr_0.9fr] p-2 mt-10 text-center font-bold  dark:bg-slate-700"
            >
              <span>Banco</span>
              <span>Agência</span>
              <span>Conta</span>
              <span>Código Contábil</span>
              <span>Ações</span>
            </div>
            {values.map((item, index) => (
              <>
                <div
                  className="grid w-full grid-cols-[1fr_1fr_1fr_1fr_0.9fr] p-2 dark:bg-slate-800 gap-3 place-items-center font-medium bg-blue-50 mb-3 rounded-xl"
                  key={item.id}
                >
                  <input
                    className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center"
                    onChange={(e) => changeValues(e, index)}
                    name="banco"
                    value={item.banco}
                  />

                  <input
                    className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center"
                    onChange={(e) => changeValues(e, index)}
                    name="agencia"
                    value={item.agencia}
                  />

                  <input
                    className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center"
                    onChange={(e) => changeValues(e, index)}
                    name="conta"
                    value={item.conta}
                  />

                  <input
                    className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center"
                    onChange={(e) => changeValues(e, index)}
                    name="codcontabil"
                    value={item.codcontabil}
                  />
                  <div className=" grid grid-cols-2 items-center gap-3 text-center rounded-md dark:bg-yellow-700 dark:text-white p-2">
                    <Tooltip title="Confirmar">
                      <button
                        onClick={() => {
                          handleUpdateEmpresa(item);
                        }}
                        className="px-4 py-2 bg-[#41A700] rounded-md hover:bg-[#308941]"
                      >
                        <FontAwesomeIcon icon={faCheck} size="lg" />
                      </button>
                    </Tooltip>
                    <Tooltip title="Cancelar">
                      <button
                        className="px-4 py-2 bg-[#999999] rounded-md hover:bg-[#999999] text-white"
                        onClick={() => setUpdateEmpresa(false)}
                      >
                        <FontAwesomeIcon icon={faRectangleXmark} size="lg" />
                      </button>
                    </Tooltip>
                  </div>
                </div>
              </>
            ))}
          </>
        ) : (
          <>
            <div className="flex">
              <BackButton path="bancarios" text="Voltar" />
            </div>
            <div className="flex">
              <span className="text-4xl font-bold mt-3">
                Editar Dados da Empresa
              </span>
            </div>

            <div
              div
              className="grid grid-cols-[2fr_4fr_1fr] p-2 mt-5 text-center font-bold  dark:bg-slate-700"
            >
              <span>CNPJ</span>
              <span>Empresa</span>
              <span>Editar</span>
            </div>
            {empresaInfo && (
              <>
                <div className="grid w-full grid-cols-[2fr_4fr_1fr] p-2 dark:bg-slate-800 gap-3 place-items-center font-medium bg-blue-50 mb-3 rounded-xl">
                  <span className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center w-[260px]">
                    {empresaInfo.cnpj}
                  </span>
                  <span className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center w-[320px]">
                    {empresaInfo.razaosocial}
                  </span>
                  <div className=" grid grid-cols-1 items-center text-center rounded-md dark:bg-yellow-700 dark:text-white">
                    <Tooltip title="Editar">
                      <button
                        className="px-4 py-2 bg-[#CCCCCC] rounded-md hover:bg-[#999999] text-black"
                        onClick={() => setUpdateEmpresa(true)}
                      >
                        <FontAwesomeIcon icon={faPenToSquare} size="lg" />
                      </button>
                    </Tooltip>
                  </div>
                </div>
              </>
            )}

            <div
              div
              className="grid justify-between grid-cols-[1fr_0.8fr_0.8fr_0.8fr_0.5fr] p-2 mt-10 text-center font-bold dark:bg-slate-700"
            >
              <span>Banco</span>
              <span>Agência</span>
              <span>Conta</span>
              <span>Código Contábil</span>
              <span>Ações</span>
            </div>
            {empresa.map((conta) => (
              <div
                className="grid w-full grid-cols-[1fr_0.8fr_0.8fr_0.8fr_0.5fr] p-2 dark:bg-slate-800 gap-3 place-items-center font-medium bg-blue-50 mb-3 rounded-xl"
                key={conta.id}
              >
                <span className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center w-full">
                  {conta.banco}
                </span>
                <span className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center w-full">
                  {conta.agencia}
                </span>
                <span className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center w-full">
                  {conta.conta}
                </span>
                <span className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center w-full">
                  {conta.codcontabil === null
                    ? "Sem informação"
                    : conta.codcontabil}
                </span>
                <div className=" grid grid-cols-2 items-center gap-5 text-center rounded-md dark:bg-yellow-700 dark:text-white p-2 w-full">
                  <Tooltip title="Editar">
                    <button
                      className="px-4 py-2 bg-[#CCCCCC] rounded-md hover:bg-[#999999] text-black"
                      onClick={() => setUpdateEmpresa(true)}
                    >
                      <FontAwesomeIcon icon={faPenToSquare} size="lg" />
                    </button>
                  </Tooltip>
                  <Tooltip title="Função desativada">
                    <button
                      className="px-4 py-2 bg-[#FC3D39] rounded-md hover:bg-[#999999] text-white cursor-not-allowed"
                      disabled
                    >
                      <FontAwesomeIcon icon={faTrashCan} size="lg" />
                    </button>
                  </Tooltip>
                </div>
              </div>
            ))}
          </>
        )}
        <Link
          className="p-4 font-semibold text-center text-black bg-blue-100 rounded-lg hover:bg-blue-300 mt-5"
          to={`/${cnpj}/contasDetalhe`}
        >
          <FontAwesomeIcon icon={faEye} size="lg" className="w-5 h-5 mt-5" />{" "}
          Plano de Contas
        </Link>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({ auth: state.auth });
export default connect(mapStateToProps)(UpdateEmpresa);
